export default "__VITE_ASSET__DHMm4YwG__"